import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import QuestionCard from 'components/Questionnaires/QuestionCard';
import MatchedForm from 'components/Questionnaires/PreQualifyingQuestionnaire/MatchedForm';
import UnsupportedForm from 'components/Questionnaires/PreQualifyingQuestionnaire/UnsupportedForm';
import questionProp from 'common/questionnaires/questionDataProp';
import { shapeQuestionsForQuestionCards } from 'common/questionnaires/questionnaireHelper';
import { history } from 'containers/App';

const PreQualifyingQuestionnaire = ({ usePreQualifyingQuestionnaire, availableFormTypes, formMatched, questions, customerName }) => {
  if (usePreQualifyingQuestionnaire === false) {
    history.push('/form-selection');
  }

  const matchedFormAllowed = !!(formMatched && availableFormTypes
    && availableFormTypes.find(f => f.formType === formMatched.formType && f.isEnabled === true && f.isVisible === true));

  return (
    <React.Fragment>
      {customerName && customerName !== '' && <div className="questionnaire pre-qualifying-questionnaire">
        { questions && questions.length !== 0 && shapeQuestionsForQuestionCards(questions).map(({ id, cardQuestions }, i, questionCards) => (
          id && cardQuestions && <QuestionCard key={ id } questionsData={ cardQuestions } isLastCard={ i === questionCards.length - 1 } />
        ))}
        {formMatched && formMatched.formType && matchedFormAllowed && <MatchedForm matchedFormId={ formMatched.formType } />}
        {formMatched && formMatched.formTitle && !matchedFormAllowed && <UnsupportedForm formTitle={ formMatched.formTitle } />}
      </div>}
    </React.Fragment>
  );
};

PreQualifyingQuestionnaire.propTypes = {
  usePreQualifyingQuestionnaire: PropTypes.bool,
  customerName: PropTypes.string,
  availableFormTypes: PropTypes.arrayOf(PropTypes.shape({})),
  formMatched: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    formType: PropTypes.string,
    formTitle: PropTypes.string
  })]),
  questions: PropTypes.arrayOf(questionProp)
};

PreQualifyingQuestionnaire.defaultProps = {
  usePreQualifyingQuestionnaire: true,
  customerName: '',
  availableFormTypes: [],
  formMatched: false,
  questions: []
};

function mapStateToProps(state) {
  const {
    app: { onlineConfig },
    preQualifyingQuestionnaire: { formMatched, questions }
  } = state;

  return {
    usePreQualifyingQuestionnaire: onlineConfig && onlineConfig.usePreQualifyingQuestionnaire,
    customerName: onlineConfig && onlineConfig.customerName,
    formMatched,
    questions,
    availableFormTypes: onlineConfig && onlineConfig.formTypes
  };
}

export default connect(
  mapStateToProps,
)(PreQualifyingQuestionnaire);
